import React, { useState, useEffect } from 'react';
import { HomeURL } from '../services/Webservice';
import { FaTrash, FaSearch, FaEdit, FaPlus, FaTimes } from 'react-icons/fa';
import './Departments.css';

function Departments() {
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [editingDept, setEditingDept] = useState(null);

    // Initial state logic
    const [formData, setFormData] = useState({ DEPT_NAME: '' });

    useEffect(() => { fetchDepartments(); }, []);

    const fetchDepartments = async () => {
        setLoading(true);
        try {
            const fd = new FormData();
            fd.append('Xml', JSON.stringify([{}]));
            fd.append('Flag', '4');
            const response = await fetch(`${HomeURL}api/Admin/DeptCrud`, { method: 'POST', body: fd });
            const data = await response.json();
            if (Array.isArray(data)) setDepartments(data);
        } catch (error) {
            console.error('Dept Fetch Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const formatDateBox = (dateString) => {
        if (!dateString) return <span className="no-date">N/A</span>;
        const dateObj = new Date(dateString);
        const day = dateObj.getDate();
        const month = dateObj.toLocaleString('en-US', { month: 'short' }).toUpperCase();
        const year = dateObj.getFullYear();

        return (
            <div className="date-display-box">
                <span className="date-day">{day}</span>
                <div className="date-month-year">
                    <span className="date-month">{month}</span>
                    <span className="date-year">{year}</span>
                </div>
            </div>
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Flag 2 for Update, 1 for Add
        const flag = editingDept ? '2' : '1';

        // ???????? ??????: API ????????? ? ???? ?????????? ??? ?????? (DEPT_ID, DEPT_NAME)
        const xmlData = JSON.stringify([{
            DEPT_ID: editingDept ? editingDept.DEPT_ID : 0,
            DEPT_NAME: formData.DEPT_NAME,
            STATUS: true
        }]);

        try {
            const fd = new FormData();
            fd.append('Xml', xmlData);
            fd.append('Flag', flag);

            const response = await fetch(`${HomeURL}api/Admin/DeptCrud`, {
                method: 'POST',
                body: fd
            });

            const resText = await response.text();

            if (resText.includes("SUCCESS")) {
                alert(editingDept ? 'Updated Successfully!' : 'Added Successfully!');
                setShowModal(false);
                setEditingDept(null); // Reset after save
                fetchDepartments();
            } else {
                alert("Response: " + resText);
            }
        } catch (error) {
            console.error(error);
            alert('Failed to save');
        }
    };

    const handleEditClick = (dept) => {
        setEditingDept(dept);
        setFormData({ DEPT_NAME: dept.DEPT_NAME }); // ??????? ?? ?????? ???????? ???????????
        setShowModal(true);
    };

    const handleDelete = async (dept) => {
        if (!window.confirm(`Delete ${dept.DEPT_NAME}?`)) return;
        const fd = new FormData();
        fd.append('xml', JSON.stringify([{ DEPT_ID: dept.DEPT_ID }]));
        fd.append('flag', '3');
        const response = await fetch(`${HomeURL}api/Admin/DeptCrud`, { method: 'POST', body: fd });
        const resText = await response.text();
        if (resText.includes("SUCCESS")) fetchDepartments();
    };

    const filteredDepts = departments.filter(d =>
        d.DEPT_NAME?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="lab-tests-container">
            <div className="header-flex">
                <div className="welcome-section">
                    <h1>Department Master</h1>
                    <p>Manage laboratory departments and categories</p>
                </div>
                <button className="add-btn-main" onClick={() => { setEditingDept(null); setFormData({ DEPT_NAME: '' }); setShowModal(true); }}>
                    <FaPlus /> Add Department
                </button>
            </div>

            <div className="table-card">
                <div className="search-wrapper">
                    <FaSearch className="search-icon-inside" />
                    <input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>

                <div className="table-responsive">
                    <table className="employee-style-table">
                        <thead>
                            <tr>
                                <th className="sticky-col">Actions</th>
                                <th>Department Name</th>
                                <th>Created Date</th>
                            {/*    <th>Status</th>*/}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="4" className="loading-state">Loading...</td></tr>
                            ) : (
                                filteredDepts.map((dept) => (
                                    <tr key={dept.DEPT_ID}>
                                        <td className="sticky-col">
                                            <div className="action-btns-flex">
                                                <button className="edit-icon-btn" onClick={() => { setEditingDept(dept); setFormData(dept); setShowModal(true); }}><FaEdit /></button>
                                                <button className="delete-icon-btn" onClick={() => handleDelete(dept)}><FaTrash /></button>
                                            </div>
                                        </td>
                                        <td><b>{dept.DEPT_NAME}</b></td>
                                        <td>{formatDateBox(dept.CREATEDDATE)}</td>
                                    {/*    <td><span className="code-badge">Active</span></td>*/}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content small-modal">
                        <div className="modal-header">
                            <h2>{editingDept ? 'Update' : 'Add'} Department</h2>
                            <FaTimes onClick={() => setShowModal(false)} className="close-x" />
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="input-box">
                                <label>Department Name</label>
                                <input
                                    required
                                    value={formData.DEPT_NAME}
                                    onChange={(e) => setFormData({ ...formData, DEPT_NAME: e.target.value })}
                                />
                            </div>
                            <button type="submit" className="save-btn">
                                {editingDept ? 'Update Department' : 'Save Department'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Departments;